import { createSlice } from "@reduxjs/toolkit";

interface ISnackbar {
  snackbarMessage: string;
  snackbarOpen: boolean;
  snackbarStatus: string;
}

const initialState: ISnackbar = {
  snackbarMessage: "",
  snackbarOpen: false,
  snackbarStatus: "",
};

const slice = createSlice({
  name: "ISnackbar",
  initialState,

  reducers: {
    // Single Payload
    SuccessSnackbar(state, action) {
      state.snackbarMessage = action.payload.message;
      state.snackbarOpen = action.payload.open;
      state.snackbarStatus = "success";
    },
    FailureSnackbar(state, action) {
      state.snackbarMessage = action.payload.message;
      state.snackbarOpen = action.payload.open;
      state.snackbarStatus = "failure";
    },
    AlertSnackbar(state, action) {
      state.snackbarMessage = action.payload.message;
      state.snackbarOpen = action.payload.open;
      state.snackbarStatus = "alert";
    },
    ClearSnackbar(state) {
      state.snackbarOpen = false;
    },
  },
});

export const SuccessSnackbar = (data) => async (dispatch) => {
  dispatch(slice.actions.SuccessSnackbar(data));
};

export const FailureSnackbar = (data) => async (dispatch) => {
  dispatch(slice.actions.FailureSnackbar(data));
};
export const AlertSnackbar = (data) => async (dispatch) => {
  dispatch(slice.actions.AlertSnackbar(data));
};

export const ClearSnackbar = () => async (dispatch) => {
  dispatch(slice.actions.ClearSnackbar());
};

export const reducer = slice.reducer;

export default slice;
